import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { CursoService } from "../../../servicios/curso.service";
import { cursoI } from '../../models/curso.interface';

import  Swal  from "sweetalert2";

import { MatDialog } from "@angular/material/dialog";
import { ModalComponent } from "../modal/modal.component";
import { ModalVideoComponent } from '../modal-video/modal-video.component';
import { config } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})

export class TableComponent implements OnInit, AfterViewInit {

  displayedColumns: string[] = ['titulo', 'content', 'tags', 'actions'];
  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator, {static:true}) paginator:MatPaginator;
  @ViewChild(MatSort, {static:true}) sort:MatSort;

  //inyecciones
  constructor(private cursoSvc:CursoService, public dialog:MatDialog, private router:Router) { }

  ngOnInit(): void {

    this.cursoSvc.getAllCursos().subscribe(res=>
      {
       // console.log(res);
        this.dataSource.data = res;
      })
    
  }

  ngAfterViewInit()
  {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  editar(curso:cursoI)
  {
   // console.log("edit", curso);
    this.openDialog(curso)

  }

  eliminar(curso:cursoI)
  {
    Swal.fire({
      title:"Estas seguro de eliminar la entrada?",
      text: "Una vez eliminado no podra recuperar la entrada",
      icon:"warning",
      showCancelButton:true,
      confirmButtonColor: '#423t32',
      cancelButtonColor: '#d33',
      confirmButtonText:"Si, borrar"
    }).then(res=>
      {        
        if(res.value)
        {
          //se quiere borrar
          this.cursoSvc.deleteCursoById(curso).then(()=>
          {
            Swal.fire("Borrado!","se ha borrao", "success");
          }).catch(()=>
          {
            Swal.fire("Error!","se ha producido un error, vuelve a intentarlo","error");
          })
         
        }
      })
  }

  newCurso()
  {
    this.openDialog();
  }

  openDialog(curso?:cursoI)
  {
    const config = 
    {
      data:{
        message: curso ? 'Editar Entrada' : 'Crear nueva Entrada',
        content: curso
      }
    };

    this.dialog.open(ModalComponent,config);
   

  }

}
